import { RoundedSkeleton } from "../skeleton/variants/RoundedSkeleton.js";
import { Stack } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/loading-placeholder/LoadingPlaceHolder.tsx
const LoadingPlaceholder = ({ rows, rowHeight = 18, rowWidth = 200, gap = "xs", "data-testid": testId }) => {
	if (!rows) return null;
	const skeletons = Array.from({ length: rows }, (_item, index) => /* @__PURE__ */ jsx(RoundedSkeleton, {
		height: rowHeight,
		width: rowWidth
	}, `skel-${index}`));
	return /* @__PURE__ */ jsx(Stack, {
		align: "stretch",
		gap,
		"data-testid": testId,
		children: skeletons
	});
};

//#endregion
export { LoadingPlaceholder };